import {FeatureName} from './feature-name.model';

export class FeatureFlag {
    name: FeatureName;
    version: String;
    isActive: boolean;

    constructor(name: FeatureName) {
        this.name = name;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/featureflags/feature-flag.model.ts